module.exports = __webpack_public_path__ + "static/media/Star-2.aedfe1f9.svg";